module.exports = "<ui-view></ui-view>\n"


//////////////////
// WEBPACK FOOTER
// ../node_modules/xo-wallet-components/src/member-sepa/template.html
// module id = ../node_modules/xo-wallet-components/src/member-sepa/template.html
// module chunks = 0